module.exports = __webpack_public_path__ + "ath_game_web/img/9.3.3e7d1d32.png";